import hexRgb from 'hex-rgb'

import tailwind from '_/tailwind.config'

export enum QRABarColorScheme {
  RISK_BY_LINE,
  THREATS,
  CONSEQUENCES,
  RISK_FORECAST_GROUP_1,
  RISK_FORECAST_GROUP_2,
  RISK_FORECAST_GROUP_3,
  RISK_FORECAST_GROUP_4
}

const baseLighthouseBlueColors: string[] = [
  tailwind.theme.colors.lighthouseBlue.DEFAULT,
  tailwind.theme.colors.lighthouseBlue[300]
]

const baseLightBlueColors: string[] = [
  tailwind.theme.colors.lightBlue.DEFAULT,
  tailwind.theme.colors.lightBlue[300]
]

const baseGreenColors: string[] = [
  tailwind.theme.colors.green.DEFAULT,
  tailwind.theme.colors.green[300]
]

const baseLimeColors: string[] = [
  tailwind.theme.colors.lime.DEFAULT,
  tailwind.theme.colors.lime[300]
]

const baseOrangeColors: string[] = [
  tailwind.theme.colors.orange.DEFAULT,
  tailwind.theme.colors.orange[300]
]

const baseRedColors: string[] = [
  tailwind.theme.colors.red.DEFAULT,
  tailwind.theme.colors.red[300]
]

/**
 * There are four different color schemes for stacked bar charts that are based on the number of categories per bar
 * In general, the more categories there are, the more colors there will be in the color scheme
 * Ref: https://janatechnology.atlassian.net/browse/LH-1494
 */
export const group1ColourScheme: string[] = [
  ...baseLighthouseBlueColors,
  ...baseLightBlueColors,
  ...baseGreenColors,
  ...baseLimeColors,
  ...baseOrangeColors,
  ...baseRedColors
]

export const group2ColourScheme: string[] = [
  tailwind.theme.colors.lighthouseBlue[600],
  ...baseLighthouseBlueColors,
  tailwind.theme.colors.lightBlue[600],
  ...baseLightBlueColors,
  tailwind.theme.colors.green[600],
  ...baseGreenColors,
  tailwind.theme.colors.lime[600],
  ...baseLimeColors,
  tailwind.theme.colors.orange[600],
  ...baseOrangeColors,
  tailwind.theme.colors.red[600],
  ...baseRedColors
]

export const group3ColourScheme: string[] = [
  tailwind.theme.colors.lighthouseBlue[600],
  ...baseLighthouseBlueColors,
  tailwind.theme.colors.lighthouseBlue[100],
  tailwind.theme.colors.lightBlue[600],
  ...baseLightBlueColors,
  tailwind.theme.colors.lightBlue[100],
  tailwind.theme.colors.green[600],
  ...baseGreenColors,
  tailwind.theme.colors.green[100],
  tailwind.theme.colors.lime[600],
  ...baseLimeColors,
  tailwind.theme.colors.lime[100],
  tailwind.theme.colors.orange[600],
  ...baseOrangeColors,
  tailwind.theme.colors.orange[100],
  tailwind.theme.colors.red[600],
  ...baseRedColors,
  tailwind.theme.colors.red[100]
]

export const group4ColourScheme: string[] = [
  tailwind.theme.colors.lighthouseBlue[700],
  tailwind.theme.colors.lighthouseBlue[600],
  ...baseLighthouseBlueColors,
  tailwind.theme.colors.lighthouseBlue[100],
  tailwind.theme.colors.lightBlue[700],
  tailwind.theme.colors.lightBlue[600],
  ...baseLightBlueColors,
  tailwind.theme.colors.lightBlue[100],
  tailwind.theme.colors.green[700],
  tailwind.theme.colors.green[600],
  ...baseGreenColors,
  tailwind.theme.colors.green[100],
  tailwind.theme.colors.lime[700],
  tailwind.theme.colors.lime[600],
  ...baseLimeColors,
  tailwind.theme.colors.lime[100],
  tailwind.theme.colors.orange[700],
  tailwind.theme.colors.orange[600],
  ...baseOrangeColors,
  tailwind.theme.colors.orange[100],
  tailwind.theme.colors.red[700],
  tailwind.theme.colors.red[600],
  ...baseRedColors,
  tailwind.theme.colors.red[100]
]

// Returns the color scheme based on the number of categories
export const getGroupColorScheme = (
  categoryCount: number = 0
): QRABarColorScheme => {
  if (categoryCount < 12) {
    return QRABarColorScheme.RISK_FORECAST_GROUP_1
  } else if (categoryCount < 18) {
    return QRABarColorScheme.RISK_FORECAST_GROUP_2
  } else if (categoryCount < 24) {
    return QRABarColorScheme.RISK_FORECAST_GROUP_3
  } else {
    return QRABarColorScheme.RISK_FORECAST_GROUP_4
  }
}

export const formatHexToEsriRgb = (color: string): number[] => {
  const rgb = hexRgb(color, { format: 'array' })

  rgb[3] *= 255

  return rgb
}
